import Seo from "../components/Seo";
import "../components/booth/tokens.css";
import Nav from "../components/booth/Nav";
import Hero from "../components/booth/Hero";
import SampleDispatch from "../components/booth/SampleDispatch";
import HowItWorks from "../components/booth/HowItWorks";
import Faq from "../components/booth/Faq";
import FinalCta from "../components/booth/FinalCta";
import Footer from "../components/booth/Footer";

function Home() {
  return (
    <div className="booth">
      <Seo
        title="The Booth — Your Fantasy League's Beat Writer"
        description="Get your own beat writer for your fantasy football league. The Booth turns your ESPN or Sleeper league into AI-written weekly recaps with real stats, MVPs, and bench regret — delivered every Tuesday, with the evidence behind every line."
        path="/"
      />
      <Nav />
      <Hero />
      <SampleDispatch />
      <HowItWorks />
      <Faq />
      <FinalCta />
      <Footer />
    </div>
  );
}

export default Home;
